import { EmojiItem, gitHubEmojis } from "@tiptap/extension-emoji";
import { useEffect, useRef } from "react";

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}

const EmojiPicker: React.FC<EmojiPickerProps> = ({ onSelect, onClose }) => {
  // Reference to the div container
  const ref = useRef<HTMLDivElement | null>(null);

  // Close when clicking outside
  useEffect(() => {
    // Function executed to close this pop up
    const handleClose = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClose);
    return () => document.removeEventListener("mousedown", handleClose);
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="absolute top-5 z-50 mt-2 w-72 max-h-64 overflow-y-auto rounded-md border bg-white p-2 shadow-lg"
      style={{ width: "18rem", left: "calc(-18rem + 24px)" }}
    >
      <div className="grid grid-cols-8 gap-1">
        {gitHubEmojis.map((emoji: EmojiItem) => (
          <button
            key={emoji.name}
            className="flex items-center justify-center rounded p-1 text-lg hover:bg-neutral-100"
            onClick={() => onSelect(emoji.emoji ? emoji.emoji : "")}
            title={`:${emoji.name}:`}
            type="button"
          >
            {emoji.emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmojiPicker;
